module.exports = __webpack_public_path__ + "static/media/people of chennai.ae7ac622.jpg";